export default __webpack_public_path__ + "static/media/property-gallery2.81269a31.webp";